// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xz_a big_vp big_vh big_xe big_rg big_tr big_qx"};